var InputComponent = (function () {
    function InputComponent() {
        this.type = 'text';
        this.error = false;
    }
    return InputComponent;
}());
export { InputComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/input/input.component.ts.pre-build-optimizer.js